import React, { createContext } from 'react';
import { injectIntl } from 'react-intl';

export const I18nContext = createContext();

export const I18nContextProvider = injectIntl(props => {
  const { intl, children, DefaultTextComponent } = props;
  return (
    <I18nContext.Provider
      value={ {
        ...intl,
        DefaultTextComponent
      } }
    >
      {children}
    </I18nContext.Provider>
  )
});

export default I18nContext;
